import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { patientDeleteTask } from 'src/redux/actions/constant';
import TherapistService from 'src/services/apiServices/therapist-scheduling/therapistService';

const {
  DELETE_PATIENT_TASK_FAILURE,
  DELETE_PATIENT_TASK_LOADER,
  DELETE_PATIENT_TASK_SUCCESS,
  DELETE_PATIENT_TASK_REQUEST,
} = patientDeleteTask;

function* deletePatientTask(action: any): SagaReturnType<any> {
  try {
    yield put({ type: DELETE_PATIENT_TASK_LOADER });
    const response = yield call(TherapistService.deletePatientTask, action.payload);
    if (response?.status === 200) {
      yield put({ type: DELETE_PATIENT_TASK_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: DELETE_PATIENT_TASK_FAILURE, payload: error });
  }
}

function* deletePatientTaskSaga() {
  yield takeEvery(DELETE_PATIENT_TASK_REQUEST, deletePatientTask);
}

export default deletePatientTaskSaga;
